module.exports={
    home: {
    	sure:'OK',
        float:{
        	updateLabel:'Update label:',
	        success:'Success:',
	        fail:'Failure:',
	        initMsg:'There are currently no tags being updated!'
        },
        dialog:{
        	msg:'Failed to get updated label status!'
        },
        tips:{
            chooseSys: 'Please contact the administrator to select the desired application scenario.'
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/en/Home.js